// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"41ea68db","453":"8b096ba3","732":"4a67aef2","977":"d9e287d3"}[chunkId] + ".chunk.js";
};